import React from 'react'
import { subscribe } from 'react-contextual'
import { Helmet } from 'react-helmet'
import { join, pick, pipe, values } from 'ramda'
import { ContactsProvider } from '../..'
import styles from './ViewContact.module.scss'
import AccountPanel from './AccountPanel/AccountPanel'
import ContactInfo from './ContactInfo/ContactInfo'
import { DimmerLoader } from '../../../../views/components'
import Close from 'views/components/atoms/Svgs/Close'
import DocumentInfo from 'modules/documents/DocumentInfo/DocumentInfo'

interface CurrentParty {
  id: string
  firstName?: string
  lastName?: string
  companyName?: string
  tradingAs?: string
}

interface ViewContactProps {
  // Contextual Props
  currentParty?: CurrentParty
  closeContact: () => void
  isContactViewLoading: boolean
}

const ViewContact = ({ currentParty, closeContact, isContactViewLoading }: ViewContactProps) => {
  const name =
    currentParty && currentParty.tradingAs
      ? currentParty.tradingAs
      : currentParty && currentParty.companyName
      ? currentParty.companyName
      : currentParty
      ? pipe(pick(['firstName', 'lastName']), values, join(' '))(currentParty)
      : 'Loading...'

  return (
    <>
      <Helmet>
        <title>reOS | Contacts | {name}</title>
      </Helmet>
      <header className={styles.header}>
        <button className={styles.close} onClick={closeContact}>
          <Close />
        </button>
      </header>
      <DimmerLoader loading={isContactViewLoading}>
        <div className={styles.body}>
          <div className="rbn--row">
            <div className="rbn--col rbn-col-md-8">
              <AccountPanel />
            </div>
            <div className="rbn--col rbn-col-md-8">
              <ContactInfo />
              {currentParty?.id && (
                <section>
                  <DocumentInfo className="party" classId={currentParty.id} modalTitle={name} />
                </section>
              )}
            </div>
          </div>
        </div>
      </DimmerLoader>
    </>
  )
}

export default subscribe([ContactsProvider], ({ currentParty, closeContact, isContactViewLoading }) => ({
  currentParty,
  closeContact,
  isContactViewLoading,
}))(ViewContact)
